var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "recovery-cont" }, [
    _c(
      "div",
      { staticClass: "recovery-header" },
      [
        _c(
          "input-wrapper-2",
          {
            attrs: {
              label: "Application",
              info: "Select the application instance for which you want to modify the settings for.",
              "label-background-light": "#D2E2DE",
              "label-background-dark": "#162627",
            },
          },
          [
            _c("v-select", {
              ref: "selectInstanceInput",
              staticStyle: { "max-width": "400px", margin: "0 0 -14px" },
              attrs: {
                items: _vm.instancesOptions,
                "item-text": "name",
                "item-value": "appId",
                placeholder: "Select Instance",
                dense: "",
                filled: "",
                rules: [_vm.rules.required],
              },
              model: {
                value: _vm.selectedInstance,
                callback: function ($$v) {
                  _vm.selectedInstance = $$v
                },
                expression: "selectedInstance",
              },
            }),
          ],
          1
        ),
      ],
      1
    ),
    _c("div", { staticClass: "recovery-content" }, [
      _c(
        "div",
        { staticClass: "recovery-cards" },
        [
          _c(
            "v-card",
            { staticClass: "recovery-card debug-card" },
            [
              _c(
                "v-card-title",
                { staticClass: "recovery-card_title" },
                [
                  _vm._v(" Trade Recovery Settings "),
                  _c(
                    "v-tooltip",
                    {
                      attrs: { bottom: "" },
                      scopedSlots: _vm._u([
                        {
                          key: "activator",
                          fn: function ({ on }) {
                            return [
                              _c(
                                "v-icon",
                                _vm._g(
                                  {
                                    staticClass: "input-info recovery-tooltip",
                                    attrs: { size: "1em", color: "blue" },
                                  },
                                  on
                                ),
                                [_vm._v(" fas fa-info-circle ")]
                              ),
                            ]
                          },
                        },
                      ]),
                    },
                    [
                      _c("div", [
                        _vm._v(" Viable Combinations "),
                        _c("ul", [
                          _c("li", [
                            _vm._v("filter, recoveryconflict, tickets"),
                          ]),
                          _c("li", [
                            _vm._v(
                              "filter, recoveryconflict, logins, from, to"
                            ),
                          ]),
                          _c("li", [
                            _vm._v(
                              "filter, recoveryconflict, logins, symbol, from, to"
                            ),
                          ]),
                          _c("li", [
                            _vm._v("filter, recoveryconflict, group, from, to"),
                          ]),
                          _c("li", [
                            _vm._v(
                              "filter, recoveryconflict, group, symbol, from, to"
                            ),
                          ]),
                        ]),
                      ]),
                    ]
                  ),
                ],
                1
              ),
              _c(
                "input-wrapper",
                {
                  attrs: {
                    label: "Filter",
                    info: "Should the groupmask and user exclusions be applied",
                    "container-class": "pt-8",
                    "label-background": _vm.$vuetify.theme.dark
                      ? "rgb(30,30,30)"
                      : "#FFFFFF",
                  },
                },
                [
                  _c(
                    "div",
                    { staticClass: "py-1 px-1" },
                    [
                      _c("v-switch", {
                        staticStyle: { "margin-top": "0" },
                        attrs: {
                          label:
                            _vm.tradeRecoverySettings.filter === true
                              ? "Yes"
                              : "No",
                          "hide-details": "",
                        },
                        model: {
                          value: _vm.tradeRecoverySettings.filter,
                          callback: function ($$v) {
                            _vm.$set(_vm.tradeRecoverySettings, "filter", $$v)
                          },
                          expression: "tradeRecoverySettings.filter",
                        },
                      }),
                    ],
                    1
                  ),
                ]
              ),
              _c(
                "input-wrapper",
                {
                  attrs: {
                    label: "Recovery Conflict",
                    info: "The operator must choose one of the 2 values",
                    "container-class": "pt-2",
                    "label-background": _vm.$vuetify.theme.dark
                      ? "rgb(30,30,30)"
                      : "#FFFFFF",
                  },
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "px-1",
                      staticStyle: { display: "contents" },
                    },
                    [
                      _c("v-select", {
                        staticStyle: { display: "contents" },
                        attrs: {
                          items: _vm.recoveryconflictOptions,
                          "item-text":
                            _vm.tradeRecoverySettings.recoveryconflict.text,
                          "item-value":
                            _vm.tradeRecoverySettings.recoveryconflict.value,
                          filled: "",
                          dense: "",
                          "hide-details": "",
                        },
                        model: {
                          value: _vm.tradeRecoverySettings.recoveryconflict,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.tradeRecoverySettings,
                              "recoveryconflict",
                              $$v
                            )
                          },
                          expression: "tradeRecoverySettings.recoveryconflict",
                        },
                      }),
                    ],
                    1
                  ),
                ]
              ),
              _c(
                "input-wrapper",
                {
                  attrs: {
                    label: "Tickets",
                    info: "Array of tickets",
                    "container-class": "pt-2",
                    "label-background": _vm.$vuetify.theme.dark
                      ? "rgb(30,30,30)"
                      : "#FFFFFF",
                  },
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "px-1",
                      staticStyle: { display: "contents" },
                    },
                    [
                      _c("v-text-field", {
                        staticStyle: { display: "contents" },
                        attrs: {
                          filled: "",
                          dense: "",
                          "hide-details": "",
                          "hide-spin-buttons": "",
                          type: "text",
                        },
                        model: {
                          value: _vm.tradeRecoverySettings.tickets,
                          callback: function ($$v) {
                            _vm.$set(_vm.tradeRecoverySettings, "tickets", $$v)
                          },
                          expression: "tradeRecoverySettings.tickets",
                        },
                      }),
                    ],
                    1
                  ),
                ]
              ),
              _c(
                "input-wrapper",
                {
                  attrs: {
                    label: "Logins",
                    info: "Array of client logins",
                    "container-class": "pt-2",
                    "label-background": _vm.$vuetify.theme.dark
                      ? "rgb(30,30,30)"
                      : "#FFFFFF",
                  },
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "px-1",
                      staticStyle: { display: "contents" },
                    },
                    [
                      _c("v-text-field", {
                        staticStyle: { display: "contents" },
                        attrs: {
                          filled: "",
                          dense: "",
                          "hide-details": "",
                          "hide-spin-buttons": "",
                          type: "text",
                        },
                        model: {
                          value: _vm.tradeRecoverySettings.logins,
                          callback: function ($$v) {
                            _vm.$set(_vm.tradeRecoverySettings, "logins", $$v)
                          },
                          expression: "tradeRecoverySettings.logins",
                        },
                      }),
                    ],
                    1
                  ),
                ]
              ),
              _c(
                "input-wrapper",
                {
                  attrs: {
                    label: "Symbol",
                    info: "Symbol name if we are interested only for the trades of one symbol",
                    "container-class": "pt-2",
                    "label-background": _vm.$vuetify.theme.dark
                      ? "rgb(30,30,30)"
                      : "#FFFFFF",
                  },
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "px-1",
                      staticStyle: { display: "contents" },
                    },
                    [
                      _c("v-text-field", {
                        staticStyle: { display: "contents" },
                        attrs: { filled: "", dense: "", "hide-details": "" },
                        model: {
                          value: _vm.tradeRecoverySettings.symbol,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.tradeRecoverySettings,
                              "symbol",
                              _vm._n($$v)
                            )
                          },
                          expression: "tradeRecoverySettings.symbol",
                        },
                      }),
                    ],
                    1
                  ),
                ]
              ),
              _c(
                "input-wrapper",
                {
                  attrs: {
                    label: "Group",
                    info: "Groupmask",
                    "container-class": "pt-2",
                    "label-background": _vm.$vuetify.theme.dark
                      ? "rgb(30,30,30)"
                      : "#FFFFFF",
                  },
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "px-1",
                      staticStyle: { display: "contents" },
                    },
                    [
                      _c("v-text-field", {
                        staticStyle: { display: "contents" },
                        attrs: { filled: "", dense: "", "hide-details": "" },
                        model: {
                          value: _vm.tradeRecoverySettings.group,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.tradeRecoverySettings,
                              "group",
                              _vm._n($$v)
                            )
                          },
                          expression: "tradeRecoverySettings.group",
                        },
                      }),
                    ],
                    1
                  ),
                ]
              ),
              _c(
                "input-wrapper",
                {
                  attrs: {
                    label: "From",
                    "container-class": "pt-2",
                    "label-background": _vm.$vuetify.theme.dark
                      ? "rgb(30,30,30)"
                      : "#FFFFFF",
                  },
                },
                [
                  _c(
                    "div",
                    { staticClass: "px-1" },
                    [
                      _c("flat-pickr", {
                        ref: "tradeRecoveryFrom",
                        attrs: {
                          config: _vm.dateTimePickerConfig,
                          placeholder: "select date and time",
                        },
                        on: {
                          "on-open": function ($event) {
                            return _vm.openDatePickerHandler(
                              "tradeRecoveryFrom"
                            )
                          },
                          "on-close": function ($event) {
                            return _vm.closeDatePickerHandler(
                              "tradeRecoveryFrom"
                            )
                          },
                        },
                        model: {
                          value: _vm.tradeRecoverySettings.from,
                          callback: function ($$v) {
                            _vm.$set(_vm.tradeRecoverySettings, "from", $$v)
                          },
                          expression: "tradeRecoverySettings.from",
                        },
                      }),
                      _c(
                        "v-btn",
                        { attrs: { icon: "", ripple: false } },
                        [
                          _c(
                            "v-icon",
                            {
                              class: _vm.datePickerPanels.tradeRecoveryFrom
                                ? "date-picker-icon active"
                                : "date-picker-icon",
                              attrs: { size: "20px", dense: "" },
                              on: {
                                click: function ($event) {
                                  _vm.datePickerPanels.tradeRecoveryFrom
                                    ? _vm.acceptDatePickerHandler(
                                        "tradeRecoveryFrom"
                                      )
                                    : _vm.openDatePickerPanel(
                                        "tradeRecoveryFrom"
                                      )
                                },
                              },
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.datePickerPanels.tradeRecoveryFrom
                                      ? "fas fa-check"
                                      : "far fa-calendar"
                                  ) +
                                  " "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                      _c(
                        "v-icon",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.datePickerPanels.tradeRecoveryFrom,
                              expression: "datePickerPanels.tradeRecoveryFrom",
                            },
                          ],
                          staticClass: "date-picker-icon",
                          attrs: { color: "red", size: "20px", dense: "" },
                          on: {
                            click: function ($event) {
                              return _vm.clearDatePickerHandler(
                                "tradeRecoveryFrom"
                              )
                            },
                          },
                        },
                        [_vm._v(" fas fa-times ")]
                      ),
                    ],
                    1
                  ),
                ]
              ),
              _c(
                "input-wrapper",
                {
                  attrs: {
                    label: "To",
                    "container-class": "pt-2",
                    "label-background": _vm.$vuetify.theme.dark
                      ? "rgb(30,30,30)"
                      : "#FFFFFF",
                  },
                },
                [
                  _c(
                    "div",
                    { staticClass: "px-1" },
                    [
                      _c("flat-pickr", {
                        ref: "tradeRecoveryTo",
                        attrs: {
                          config: _vm.dateTimePickerConfig,
                          placeholder: "select date and time",
                        },
                        on: {
                          "on-open": function ($event) {
                            return _vm.openDatePickerHandler("tradeRecoveryTo")
                          },
                          "on-close": function ($event) {
                            return _vm.closeDatePickerHandler("tradeRecoveryTo")
                          },
                        },
                        model: {
                          value: _vm.tradeRecoverySettings.to,
                          callback: function ($$v) {
                            _vm.$set(_vm.tradeRecoverySettings, "to", $$v)
                          },
                          expression: "tradeRecoverySettings.to",
                        },
                      }),
                      _c(
                        "v-btn",
                        { attrs: { icon: "", ripple: false } },
                        [
                          _c(
                            "v-icon",
                            {
                              class: _vm.datePickerPanels.tradeRecoveryTo
                                ? "date-picker-icon active"
                                : "date-picker-icon",
                              attrs: { size: "20px" },
                              on: {
                                click: function ($event) {
                                  _vm.datePickerPanels.tradeRecoveryTo
                                    ? _vm.acceptDatePickerHandler(
                                        "tradeRecoveryTo"
                                      )
                                    : _vm.openDatePickerPanel("tradeRecoveryTo")
                                },
                              },
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.datePickerPanels.tradeRecoveryTo
                                      ? "fas fa-check"
                                      : "far fa-calendar"
                                  ) +
                                  " "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                      _c(
                        "v-icon",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.datePickerPanels.tradeRecoveryTo,
                              expression: "datePickerPanels.tradeRecoveryTo",
                            },
                          ],
                          staticClass: "date-picker-icon",
                          attrs: { color: "red", size: "20px" },
                          on: {
                            click: function ($event) {
                              return _vm.clearDatePickerHandler(
                                "tradeRecoveryTo"
                              )
                            },
                          },
                        },
                        [_vm._v(" fas fa-times ")]
                      ),
                    ],
                    1
                  ),
                ]
              ),
              _c(
                "v-card-actions",
                { staticClass: "recovery-actions" },
                [
                  _c(
                    "v-btn",
                    {
                      attrs: { plain: "" },
                      on: { click: _vm.cancelTradeRecoverySettings },
                    },
                    [_vm._v(" Cancel ")]
                  ),
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        color: "primary",
                        loading: _vm.savingTrades,
                        disabled: !_vm.selectedInstance,
                      },
                      on: { click: _vm.saveTradeRecoverySettings },
                    },
                    [_vm._v(" Save ")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "v-card",
            { staticClass: "recovery-card debug-card d-flex flex-column" },
            [
              _c(
                "v-card-title",
                { staticClass: "recovery-card_title" },
                [
                  _vm._v(" Daily Report Recovery Settings "),
                  _c(
                    "v-tooltip",
                    {
                      attrs: { bottom: "" },
                      scopedSlots: _vm._u([
                        {
                          key: "activator",
                          fn: function ({ on }) {
                            return [
                              _c(
                                "v-icon",
                                _vm._g(
                                  {
                                    staticClass: "input-info recovery-tooltip",
                                    attrs: { size: "1em", color: "blue" },
                                  },
                                  on
                                ),
                                [_vm._v(" fas fa-info-circle ")]
                              ),
                            ]
                          },
                        },
                      ]),
                    },
                    [
                      _c("div", [
                        _vm._v(" Viable Combinations "),
                        _c("ul", [
                          _c("li", [
                            _vm._v(
                              "filter, recoveryconflict, logins, from, to"
                            ),
                          ]),
                          _c("li", [
                            _vm._v("filter, recoveryconflict, group, from, to"),
                          ]),
                        ]),
                      ]),
                    ]
                  ),
                ],
                1
              ),
              _c(
                "input-wrapper",
                {
                  attrs: {
                    label: "Filter",
                    info: "Should the groupmask and user exclusions be applied",
                    "container-class": "pt-8",
                    "label-background": _vm.$vuetify.theme.dark
                      ? "rgb(30,30,30)"
                      : "#FFFFFF",
                  },
                },
                [
                  _c(
                    "div",
                    { staticClass: "py-1 px-1" },
                    [
                      _c("v-switch", {
                        staticStyle: { "margin-top": "0" },
                        attrs: {
                          label:
                            _vm.dailyReportRecoverySettings.filter === true
                              ? "Yes"
                              : "No",
                          "hide-details": "",
                        },
                        model: {
                          value: _vm.dailyReportRecoverySettings.filter,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.dailyReportRecoverySettings,
                              "filter",
                              $$v
                            )
                          },
                          expression: "dailyReportRecoverySettings.filter",
                        },
                      }),
                    ],
                    1
                  ),
                ]
              ),
              _c(
                "input-wrapper",
                {
                  attrs: {
                    label: "Recovery Conflict",
                    info: "The operator must choose one of the 2 values",
                    "container-class": "pt-8",
                    "label-background": _vm.$vuetify.theme.dark
                      ? "rgb(30,30,30)"
                      : "#FFFFFF",
                  },
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "px-1",
                      staticStyle: { display: "contents" },
                    },
                    [
                      _c("v-select", {
                        staticStyle: { display: "contents" },
                        attrs: {
                          items: _vm.recoveryconflictOptions,
                          "item-text":
                            _vm.dailyReportRecoverySettings.recoveryconflict
                              .text,
                          "item-value":
                            _vm.dailyReportRecoverySettings.recoveryconflict
                              .value,
                          filled: "",
                          dense: "",
                          "hide-details": "",
                        },
                        model: {
                          value:
                            _vm.dailyReportRecoverySettings.recoveryconflict,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.dailyReportRecoverySettings,
                              "recoveryconflict",
                              $$v
                            )
                          },
                          expression:
                            "dailyReportRecoverySettings.recoveryconflict",
                        },
                      }),
                    ],
                    1
                  ),
                ]
              ),
              _c(
                "input-wrapper",
                {
                  attrs: {
                    label: "Logins",
                    info: "Array of client logins",
                    "container-class": "pt-2",
                    "label-background": _vm.$vuetify.theme.dark
                      ? "rgb(30,30,30)"
                      : "#FFFFFF",
                  },
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "px-1",
                      staticStyle: { display: "contents" },
                    },
                    [
                      _c("v-text-field", {
                        staticStyle: { display: "contents" },
                        attrs: {
                          filled: "",
                          dense: "",
                          "hide-details": "",
                          "hide-spin-buttons": "",
                          type: "text",
                        },
                        model: {
                          value: _vm.dailyReportRecoverySettings.logins,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.dailyReportRecoverySettings,
                              "logins",
                              $$v
                            )
                          },
                          expression: "dailyReportRecoverySettings.logins",
                        },
                      }),
                    ],
                    1
                  ),
                ]
              ),
              _c(
                "input-wrapper",
                {
                  attrs: {
                    label: "Group",
                    info: "Groupmask",
                    "container-class": "pt-2",
                    "label-background": _vm.$vuetify.theme.dark
                      ? "rgb(30,30,30)"
                      : "#FFFFFF",
                  },
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "px-1",
                      staticStyle: { display: "contents" },
                    },
                    [
                      _c("v-text-field", {
                        staticStyle: { display: "contents" },
                        attrs: { filled: "", dense: "", "hide-details": "" },
                        model: {
                          value: _vm.dailyReportRecoverySettings.group,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.dailyReportRecoverySettings,
                              "group",
                              _vm._n($$v)
                            )
                          },
                          expression: "dailyReportRecoverySettings.group",
                        },
                      }),
                    ],
                    1
                  ),
                ]
              ),
              _c(
                "input-wrapper",
                {
                  attrs: {
                    label: "From",
                    "container-class": "pt-2",
                    "label-background": _vm.$vuetify.theme.dark
                      ? "rgb(30,30,30)"
                      : "#FFFFFF",
                  },
                },
                [
                  _c(
                    "div",
                    { staticClass: "px-1" },
                    [
                      _c("flat-pickr", {
                        ref: "dailyReportFrom",
                        attrs: {
                          config: _vm.dateTimePickerConfig,
                          pickername: "dailyReportFrom",
                          placeholder: "select date and time",
                        },
                        on: {
                          "on-open": function ($event) {
                            return _vm.openDatePickerHandler("dailyReportFrom")
                          },
                          "on-close": function ($event) {
                            return _vm.closeDatePickerHandler("dailyReportFrom")
                          },
                        },
                        model: {
                          value: _vm.dailyReportRecoverySettings.from,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.dailyReportRecoverySettings,
                              "from",
                              $$v
                            )
                          },
                          expression: "dailyReportRecoverySettings.from",
                        },
                      }),
                      _c(
                        "v-btn",
                        { attrs: { icon: "", ripple: false } },
                        [
                          _c(
                            "v-icon",
                            {
                              class: _vm.datePickerPanels.dailyReportFrom
                                ? "date-picker-icon active"
                                : "date-picker-icon",
                              attrs: { size: "20px" },
                              on: {
                                click: function ($event) {
                                  _vm.datePickerPanels.dailyReportFrom
                                    ? _vm.acceptDatePickerHandler(
                                        "dailyReportFrom"
                                      )
                                    : _vm.openDatePickerPanel("dailyReportFrom")
                                },
                              },
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.datePickerPanels.dailyReportFrom
                                      ? "fas fa-check"
                                      : "far fa-calendar"
                                  ) +
                                  " "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                      _c(
                        "v-icon",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.datePickerPanels.dailyReportFrom,
                              expression: "datePickerPanels.dailyReportFrom",
                            },
                          ],
                          staticClass: "date-picker-icon",
                          attrs: { color: "red", size: "20px", dense: "" },
                          on: {
                            click: function ($event) {
                              return _vm.clearDatePickerHandler(
                                "dailyReportFrom"
                              )
                            },
                          },
                        },
                        [_vm._v(" fas fa-times ")]
                      ),
                    ],
                    1
                  ),
                ]
              ),
              _c(
                "input-wrapper",
                {
                  attrs: {
                    label: "To",
                    "container-class": "pt-2",
                    "label-background": _vm.$vuetify.theme.dark
                      ? "rgb(30,30,30)"
                      : "#FFFFFF",
                  },
                },
                [
                  _c(
                    "div",
                    { staticClass: "px-1" },
                    [
                      _c("flat-pickr", {
                        ref: "dailyReportTo",
                        attrs: {
                          config: _vm.dateTimePickerConfig,
                          placeholder: "select date and time",
                        },
                        on: {
                          "on-open": function ($event) {
                            return _vm.openDatePickerHandler("dailyReportTo")
                          },
                          "on-close": function ($event) {
                            return _vm.closeDatePickerHandler("dailyReportTo")
                          },
                        },
                        model: {
                          value: _vm.dailyReportRecoverySettings.to,
                          callback: function ($$v) {
                            _vm.$set(_vm.dailyReportRecoverySettings, "to", $$v)
                          },
                          expression: "dailyReportRecoverySettings.to",
                        },
                      }),
                      _c(
                        "v-btn",
                        { attrs: { icon: "", ripple: false } },
                        [
                          _c(
                            "v-icon",
                            {
                              class: _vm.datePickerPanels.dailyReportTo
                                ? "date-picker-icon active"
                                : "date-picker-icon",
                              attrs: { size: "20px" },
                              on: {
                                click: function ($event) {
                                  _vm.datePickerPanels.dailyReportTo
                                    ? _vm.acceptDatePickerHandler(
                                        "dailyReportTo"
                                      )
                                    : _vm.openDatePickerPanel("dailyReportTo")
                                },
                              },
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.datePickerPanels.dailyReportTo
                                      ? "fas fa-check"
                                      : "far fa-calendar"
                                  ) +
                                  " "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                      _c(
                        "v-icon",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.datePickerPanels.dailyReportTo,
                              expression: "datePickerPanels.dailyReportTo",
                            },
                          ],
                          staticClass: "date-picker-icon",
                          attrs: { color: "red", size: "20px", ripple: false },
                          on: {
                            click: function ($event) {
                              return _vm.clearDatePickerHandler("dailyReportTo")
                            },
                          },
                        },
                        [_vm._v(" fas fa-times ")]
                      ),
                    ],
                    1
                  ),
                ]
              ),
              _c("v-spacer"),
              _c(
                "v-card-actions",
                { staticClass: "recovery-actions" },
                [
                  _c(
                    "v-btn",
                    {
                      attrs: { plain: "" },
                      on: { click: _vm.cancelDailyRecoverySettings },
                    },
                    [_vm._v(" Cancel ")]
                  ),
                  _c(
                    "span",
                    { on: { mouseenter: _vm.touchError } },
                    [
                      _c(
                        "v-btn",
                        {
                          attrs: {
                            color: "primary",
                            loading: _vm.savingDaily,
                            disabled: !_vm.selectedInstance,
                          },
                          on: { click: _vm.saveDailyRecoverySettings },
                        },
                        [_vm._v(" Save ")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }